module.exports = __webpack_public_path__ + "assets/img/robert_taylor_photo.82dd42c8.svg";